import React from 'react';

import Tooltip from 'ui/Tooltip';

import { HelpIcon } from './styles';

type FieldHelpIconProps = {
  name: string;
  helpText: string;
};

const FieldHelpIcon: React.FC<FieldHelpIconProps> = ({ name, helpText }) => (
  <Tooltip title={helpText} placement="right">
    <HelpIcon
      role="img"
      tabIndex={0}
      aria-label={`Help: ${name}`}
      onClick={(event: React.MouseEvent) => event.stopPropagation()}
    />
  </Tooltip>
);

export default FieldHelpIcon;
